import { combineReducers } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session' // defaults to localStorage for web
import { dcrReducer } from './DCRStore';
import { historyReducer } from './HistoryStore';
import { detailsReducer } from './DetailsStore';
import { accountReducer } from './AccountStore';
import { schedulePaymentReducer } from './SchedulePaymentStore'
import { errorHandlingReducer } from './ErrorHandling';
import { helperReducer } from './HelperStore';
import { cmsReducer } from './CmsStore';
import { applicationTimeoutReducer } from './ApplicationTimeoutStore';
import { googleAnalyticsIdReducer } from './GoogleAnalyticsIdStore';
import {
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER
} from 'redux-persist'
import { configureStore } from '@reduxjs/toolkit';


const reducers = {
    dcr: dcrReducer,
    cmHistory: historyReducer,
    cmDetails: detailsReducer,
    accounts: accountReducer,
    cmSchedulePayment: schedulePaymentReducer,
    errorHandling: errorHandlingReducer,
    helper: helperReducer,
    cms: cmsReducer,
    applicationTimeout: applicationTimeoutReducer,
    googleAnalyticsId: googleAnalyticsIdReducer,
};


// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
export const history = createBrowserHistory({ basename: baseUrl ?? "" });

const rootReducer = combineReducers({
    router: connectRouter(history),
    ...reducers,
});

const persistConfig = {
    key: 'root',
    storage: storageSession,
    blacklist: ['router']
}


const persistedReducer = persistReducer(persistConfig, rootReducer)

export type AppState = ReturnType<typeof persistedReducer>;

export default function configurePersistedStore(initialState: AppState) {


    const store = configureStore({
        reducer: persistedReducer,
        middleware: getDefaultMiddleware => getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        }).concat(routerMiddleware(history)),
        devTools: process.env.NODE_ENV !== 'production',
        preloadedState: initialState
    })
    const persistor = persistStore(store)

    return { store, persistor };
}